export const newsswitchConstants = {
    ALL_NEWS: 'ALL_NEWS',
    SAVED_NEWS: 'SAVED_NEWS',


    ALL_NEWS_NR: 0,
    SAVED_NEWS_NR: 1,
};
